import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-map-route-pickup-4",
  "use": "icon-map-route-pickup-4-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-map-route-pickup-4\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M24 24H0V0h24z\" /><g transform=\"rotate(-180 11 11)\"><circle stroke=\"#000\" stroke-width=\"2\" fill=\"#FFF\" cx=\"10\" cy=\"10\" r=\"9\" /><path d=\"m9 15-4-4.5L6.333 9 7 9.75V5h2v7h-.001H9v3zm2-10 4 4.5-1.333 1.5-.667-.75V15h-2V8h.001H11V5z\" fill=\"#000\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol